module.exports = __webpack_public_path__ + "static/media/aibory-logo-main@2x.4da8b76a.png";